<template>
  <a-card>
    <div slot="title">
      <div class="m-display-flex space-between">
        <div>
          <a-icon type="pic-center" class="margin-right-small" />
          <span>PP QUEUE</span>
        </div>
        <span>Grand Total : {{ formatRupiah(grandtotalValue) }}</span>
      </div>
    </div>
    <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <a-input-search
          v-model="search"
          placeholder="input search text"
          class="margin-bottom"
        />
      </a-col>
    </a-row>
    <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <a-table
          :columns="columnsNotSet"
          :dataSource="dataQueue"
          rowKey="id_pp"
          id="notset"
          :loading="loadingNotSet"
          size="small"
          :pagination="pagination"
          bordered
          :scroll="{ x: 1300 }"
        >
          <template slot="title">
            <div class="m-display-flex space-between">
              <h4 slot="title">List PP Queue</h4>

              <div class="float-right">
                <h4 class="margin-remove">
                  Total Value check : {{ formatRupiah(total.check) }}
                </h4>
                <h4 class="margin-remove">
                  Total Value uncheck :
                  {{ formatRupiah(total.uncheck) }}
                </h4>
              </div>
            </div>
          </template>
          <a slot="no_pp" slot-scope="item" @click="handleLink(item.id_pp)">{{
            item.no_pp
          }}</a>
          <span slot="value" slot-scope="amount">
            <CurrencyJustified
              v-if="amount.estimated_value"
              :currencyValue="amount.currency"
              :valueNumber="amount.estimated_value"
            />
            <div v-else style="text-align: center; width: 100%">-</div>
          </span>
          <div
            slot="update_by"
            slot-scope="item"
            class="m-display-flex space-between"
          >
            <div>
              <h4 class="margin-remove">{{ item.direktorat }}</h4>
              <span
                >{{ item.tlc_dana }} /
                {{
                  item.tgl_buat
                    ? moment(item.tgl_buat, getDateTimeStandartFormat).format(
                        getDefaultDateFormat
                      )
                    : "-"
                }}
              </span>
            </div>
            <a-tooltip
              v-if="item.remark_keu !== null "
              class="m-tooltip-inner"
              placement="top"
              :title="item.remark_keu"
            >
              <a-button size="small" icon="ellipsis"></a-button>
            </a-tooltip>
          </div>
          <span slot="dana_sts" slot-scope="item">
            <a-button
              type="danger"
              icon="close"
              size="small"
              v-if="item.dana_sts === '0'"
            />
            <a-button
              type="primary"
              icon="check"
              size="small"
              v-else-if="item.dana_sts === '1'"
            />
          </span>
        </a-table>
      </a-col>
    </a-row>

    <a-modal v-model="modalNote" :maskClosable="false" :closable="false">
      <span slot="title"><a-icon type="send" />&nbsp;{{ tempTitle }} </span>

      <a-form :form="formNote">
        <a-form-item label="Note">
          <a-textarea
            class="m-width-full"
            v-decorator="[
              'remark',
              {
                rules: [{ required: false }],
              },
            ]"
          ></a-textarea>
        </a-form-item>
      </a-form>

      <template slot="footer">
        <a-button key="back" @click="CancelData"> Cancel </a-button>
        <a-button key="submit" type="primary" @click="PostData">
          Submit
        </a-button>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";
import Sortable from "sortablejs/modular/sortable.core.esm.js";

export default {
  name: "priority_list",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      kategori: undefined,
      searchDate: null,
      search: "",
      status: undefined,
      matauang: undefined,
      modalInfo: false,
      informasi: {
        estimated_value: 0,
        sisa_saldo: 0,
        mata_uang: null,
      },
      pageId: "",
      dataQueue: [],
      dataQueuetemp: [],
      dataNormal: [],
      dataUrgent: [],
      dataMedium: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 15,
        size: "small",
      },
      paginationUrgent: {
        current: 1,
        onChange: (page) => {
          this.paginationUrgent.current = page;
        },
        pageSize: 5,
        size: "small",
      },

      paginationMedium: {
        current: 1,
        onChange: (page) => {
          this.paginationMedium.current = page;
        },
        pageSize: 5,
        size: "small",
      },
      paginationNormal: {
        current: 1,
        onChange: (page) => {
          this.paginationNormal.current = page;
        },
        pageSize: 5,
        size: "small",
      },

      dragNotSet: [],
      dragNormal: [],
      dragUrgent: [],
      dragMedium: [],
      tempNotset: {},
      arrKode: [
        { id: 0, val: "idnotset" },
        { id: 1, val: "idurgent" },
        { id: 2, val: "idmedium" },
        { id: 3, val: "idnormal" },
      ],
      loadingUrgent: false,
      loadingNotSet: false,
      loadingNormal: false,
      loadingMedium: false,
      modalNote: false,
      tempSelf: null,
      tempData: null,
      tempNewIndexReal: null,
      tempEvt: null,
      tempTitle: null,
      total: {
        uncheck: 0,
        check: 0,
      },
      totalData: {
        total_belum_biasa: 0,
        grand_total: 0,
        total_belum_sedang: 0,
        total_belum_urgent: 0,
      },
    };
  },
  mounted() {
    this.initSetAttributeId();
    this.fetchData().then(() => {});
  },
  beforeCreate() {
    this.formNote = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getKategori",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAllMataUang",
      "getNavigation",
      "getNavigationId",
      "getDateTimeFormat",
      "getDateTimeStandartFormat",
    ]),

    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          key: "no",
          dataIndex: "seq_priority",
          width: 40,
          align: "center",
        },
        {
          title: "No PP",
          width: 100,
          key: "no_pp",
          scopedSlots: { customRender: "no_pp" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: 180,
        },

        {
          title: "Value",
          key: "value",
          width: 100,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Update By",
          key: "update_by",
          width: 130,
          scopedSlots: { customRender: "update_by" },
        },
        {
          title: "Status Dana",
          key: "dana_sts",
          width: 50,
          align: "center",
          scopedSlots: { customRender: "dana_sts" },
        },
      ];
      return kolom;
    },

    columnsNotSet() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          key: "no",
          dataIndex: "no",
          width: 40,
          align: "center",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "No PP",
          width: 100,
          key: "no_pp",
          scopedSlots: { customRender: "no_pp" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: 180,
        },

        {
          title: "Value",
          key: "estimated_value",
          width: 100,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Update By",
          key: "update_by",
          width: 130,
          scopedSlots: { customRender: "update_by" },
        },
        {
          title: "Status Dana",
          key: "dana_sts",
          width: 50,
          align: "center",
          scopedSlots: { customRender: "dana_sts" },
        },
      ];
      return kolom;
    },
    grandtotalValue() {
      return (
        this.totalData.total_belum_biasa +
        parseFloat(this.totalData.grand_total) +
        this.totalData.total_belum_sedang +
        this.totalData.total_belum_urgent
      );
    },
  },
  watch:{
    search(){
      if(this.search!=""){
        this.dataQueue = _.filter(this.dataQueuetemp,
          (element) =>
            (element.no_pp && element.no_pp .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0) ||
            (element.deskripsi && element.deskripsi .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0)
        );
      }else{
        this.dataQueue = this.dataQueuetemp;
      }
    }
  },
  methods: {
    moment,
    CancelData() {
      this.fetchData().then((res) => {
        this.modalNote = false;
      });
    },
    PostData() {
      this.formNote.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        this.postAddNormal(
          this.tempSelf,
          this.tempData.id_pp,
          this.tempNewIndexReal,
          this.tempData.used_for,
          this.tempEvt.from.id,
          this.tempEvt.to.id,
          values.remark
        );
      });
    },
    fetchData() {
      return new Promise((resolve, reject) => {
        this.dataQueue = [];
        axios({
          method: "get",
          url: this.$serviceUrl + "priority/list_ga_pur",
          params: {
            sub_menu: "purchasing",
            tlc: this.getAuth.username,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.dataQueue = response.data.list_data;
            this.totalData.grand_total = response.data.grand_total;
            this.dataQueue.forEach((value, index) => {
              this.dataQueue[index]["no"] = index + 1;
            });
            this.total = {
              check: response.data.check_total,
              uncheck: response.data.uncheck_total,
            };
            this.dataQueuetemp = this.dataQueue;
            this.loading = false;

            //setPage
            resolve(response);
          })
          .catch((err) => {
            if (!err.response) {
              this.displayMessage("error-connection-refused");
            } else {
              this.loading = false;
              this.displayMessage("empty-db");
            }

            reject(err);
          });
      });
    },

    // initSortable() {
    //     let tableSet = document.getElementById('notset');
    //     let tbodyTableSet = tableSet.querySelector("tbody");
    //     // tbodyTableSet.setAttribute('id','idnotset');

    //     // let tableNormal = document.getElementsByName('table-normal');
    //     let tableUrgent = document.getElementById('urgent');
    //     let tbodyTableUrgent = tableUrgent.querySelector("tbody");
    //     // tbodyTableUrgent.setAttribute('id','idurgent');

    //     let tableMedium = document.getElementById('medium');
    //     let tbodyTableMedium = tableMedium.querySelector("tbody");
    //     // tbodyTableMedium.setAttribute('id','idmedium');

    //     let tableNormal = document.getElementById('normal');
    //     let tbodyTableNormal = tableNormal.querySelector("tbody");
    //     // tbodyTableNormal.setAttribute('id','idmedium');

    //     const _self = this;
    //     // this way we avoid data binding

    //     Sortable.create(tbodyTableSet, {sort:false,group: {name:'notset'}});

    //     _self.dragNdrop = JSON.parse(JSON.stringify(_self.dataUrgent));
    //     Sortable.create(tbodyTableUrgent, {sort:true,group: {name:'urgent', put:['medium','notset','normal']},
    //         forceFallback: false,
    //         animation: 300,
    //         invertSwap: false,
    //         onAdd(evt){
    //             let dataTemp={};
    //             _self.modalNote = true;
    //             if(evt.from.id === 'idnotset'){
    //                 dataTemp = _self.dataQueue.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey;
    //                 })
    //             }else if(evt.from.id === 'idurgent'){
    //                 dataTemp = _self.dataUrgent.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }else if(evt.from.id === 'idmedium'){
    //                 dataTemp = _self.dataMedium.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }else if(evt.from.id === 'idnormal'){
    //                 dataTemp = _self.dataNormal.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }

    //             if(_self.isRealValue(dataTemp)){
    //                 let newIndexReal = evt.newIndex+1;
    //                 newIndexReal += (_self.paginationUrgent.current-1)*_self.paginationUrgent.pageSize;
    //                 _self.tempSelf = _self;
    //                 _self.tempData = dataTemp;
    //                 _self.tempNewIndexReal = newIndexReal;
    //                 _self.tempEvt = evt;
    //                 _self.tempTitle = dataTemp.no_pp;

    //                 // _self.postAddNormal(_self,dataTemp.id_pp, newIndexReal,dataTemp.used_for, evt.from.id, evt.to.id);
    //             }
    //         },
    //         onUpdate(evt){

    //             let dataTemp={};
    //             _self.modalNote = true;
    //             if(evt.from.id === 'idnotset'){
    //                 dataTemp = _self.dataQueue.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey;
    //                 })
    //             }else if(evt.from.id === 'idurgent'){
    //                 dataTemp = _self.dataUrgent.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }else if(evt.from.id === 'idmedium'){
    //                 dataTemp = _self.dataMedium.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }else if(evt.from.id === 'idnormal'){
    //                 dataTemp = _self.dataNormal.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }

    //             if(_self.isRealValue(dataTemp)){
    //                 let newIndexReal = evt.newIndex+1;
    //                 newIndexReal += (_self.paginationUrgent.current-1)*_self.paginationUrgent.pageSize;
    //                 _self.tempSelf = _self;
    //                 _self.tempData = dataTemp;
    //                 _self.tempNewIndexReal = newIndexReal;
    //                 _self.tempEvt = evt;
    //                 _self.tempTitle = dataTemp.no_pp;

    //                 // _self.postAddNormal(_self,dataTemp.id_pp, newIndexReal,dataTemp.used_for, evt.from.id, evt.to.id);
    //             }

    //         },
    //     });

    //     Sortable.create(tbodyTableMedium, {sort:true,group: {name:'medium', put:['notset','urgent','normal']},
    //         forceFallback: false,
    //         animation: 300,
    //         invertSwap: false,
    //         onAdd(evt){
    //             let dataTemp={};
    //             _self.modalNote = true;
    //             if(evt.from.id === 'idnotset'){
    //                 dataTemp = _self.dataQueue.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }else if(evt.from.id === 'idurgent'){
    //                 dataTemp = _self.dataUrgent.find((item)=>{
    //                     return item.id_pp === evt.item.dataset.rowKey ;
    //                 })

    //             }else if(evt.from.id === 'idmedium'){
    //                 dataTemp = _self.dataMedium.find((item)=>{
    //                     return item.id_pp === evt.item.dataset.rowKey;
    //                 })
    //             }else if(evt.from.id === 'idnormal'){
    //                 dataTemp = _self.dataNormal.find((item)=>{
    //                     return item.id_pp === evt.item.dataset.rowKey;
    //                 })
    //             }

    //             if(_self.isRealValue(dataTemp)){
    //                 let newIndexReal = evt.newIndex+1;
    //                 newIndexReal += (_self.paginationMedium.current-1)*_self.paginationMedium.pageSize;

    //                 _self.tempSelf = _self;
    //                 _self.tempData = dataTemp;
    //                 _self.tempNewIndexReal = newIndexReal;
    //                 _self.tempEvt = evt;
    //                 _self.tempTitle = dataTemp.no_pp;
    //                 // _self.postAddNormal(_self,dataTemp.id_pp, newIndexReal,dataTemp.used_for, evt.from.id, evt.to.id);
    //             }
    //         },
    //         onUpdate(evt){
    //             let dataTemp={};
    //             _self.modalNote = true;
    //             if(evt.from.id === 'idnotset'){
    //                 dataTemp = _self.dataQueue.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey;
    //                 })
    //             }else if(evt.from.id === 'idurgent'){
    //                 dataTemp = _self.dataUrgent.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }else if(evt.from.id === 'idmedium'){
    //                 dataTemp = _self.dataMedium.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }else if(evt.from.id === 'idnormal'){
    //                 dataTemp = _self.dataNormal.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }

    //             if(_self.isRealValue(dataTemp)){
    //                 let newIndexReal = evt.newIndex+1;
    //                 newIndexReal += (_self.paginationMedium.current-1)*_self.paginationMedium.pageSize;

    //                 _self.tempSelf = _self;
    //                 _self.tempData = dataTemp;
    //                 _self.tempNewIndexReal = newIndexReal;
    //                 _self.tempEvt = evt;
    //                 _self.tempTitle = dataTemp.no_pp;

    //                 // _self.postAddNormal(_self,dataTemp.id_pp, newIndexReal,dataTemp.used_for, evt.from.id, evt.to.id);
    //             }
    //         }
    //     });

    //     Sortable.create(tbodyTableNormal, {sort:true,group: {name:'normal', put:['notset','urgent','medium']},
    //         forceFallback: false,
    //         animation: 300,
    //         invertSwap: false,
    //         onAdd(evt){
    //             let dataTemp={};
    //             _self.modalNote = true;
    //             if(evt.from.id === 'idnotset'){
    //                 dataTemp = _self.dataQueue.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }else if(evt.from.id === 'idurgent'){
    //                 dataTemp = _self.dataUrgent.find((item)=>{
    //                     return item.id_pp === evt.item.dataset.rowKey ;
    //                 })

    //             }else if(evt.from.id === 'idmedium'){
    //                 dataTemp = _self.dataMedium.find((item)=>{
    //                     return item.id_pp === evt.item.dataset.rowKey;
    //                 })
    //             }else if(evt.from.id === 'idnormal'){
    //                 dataTemp = _self.dataNormal.find((item)=>{
    //                     return item.id_pp === evt.item.dataset.rowKey;
    //                 })
    //             }

    //             if(_self.isRealValue(dataTemp)){
    //                 let newIndexReal = evt.newIndex+1;
    //                 newIndexReal += (_self.paginationNormal.current-1)*_self.paginationNormal.pageSize;

    //                 _self.tempSelf = _self;
    //                 _self.tempData = dataTemp;
    //                 _self.tempNewIndexReal = newIndexReal;
    //                 _self.tempEvt = evt;
    //                 _self.tempTitle = dataTemp.no_pp;

    //                 // _self.postAddNormal(_self,dataTemp.id_pp, newIndexReal,dataTemp.used_for, evt.from.id, evt.to.id);
    //             }
    //         },
    //         onUpdate(evt){
    //             let dataTemp={};
    //             _self.modalNote = true;
    //             if(evt.from.id === 'idnotset'){
    //                 dataTemp = _self.dataQueue.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey;
    //                 })
    //             }else if(evt.from.id === 'idurgent'){
    //                 dataTemp = _self.dataUrgent.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }else if(evt.from.id === 'idmedium'){
    //                 dataTemp = _self.dataMedium.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }else if(evt.from.id === 'idnormal'){
    //                 dataTemp = _self.dataNormal.find((item)=>{
    //                     return item.id_pp == evt.item.dataset.rowKey ;
    //                 })
    //             }

    //             if(_self.isRealValue(dataTemp)){
    //                 let newIndexReal = evt.newIndex+1;
    //                 newIndexReal += (_self.paginationNormal.current-1)*_self.paginationNormal.pageSize;

    //                 _self.tempSelf = _self;
    //                 _self.tempData = dataTemp;
    //                 _self.tempNewIndexReal = newIndexReal;
    //                 _self.tempEvt = evt;
    //                 _self.tempTitle = dataTemp.no_pp;

    //                 // _self.postAddNormal(_self,dataTemp.id_pp, newIndexReal,dataTemp.used_for, evt.from.id, evt.to.id);
    //             }
    //         }
    //     });

    // },

    postAddNormal(self, id, seq, used_for, tableFrom, tableTo, remark) {
      self.loadingTableTrue(tableTo);
      self.loadingTableTrue(tableFrom);

      let priority = this.arrKode.find((item) => {
        return item.val === tableTo ? item.id : null;
      });

      axios({
        method: "post",
        url: this.$serviceUrl + "priority/posisi",
        processData: false,
        data: {
          id_pp: id,
          tlc: this.getAuth.username,
          priority: priority.id,
          seq: seq,
          used_for: used_for,
          remark: remark,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          // self.displayMessage("success");
          this.fetchData().then(() => {
            // self.initSortable();

            this.loadingTableFalse(tableTo);
            this.loadingTableFalse(tableFrom);

            this.modalNote = false;
            this.tempEvt = null;
            this.tempNewIndexReal = null;
            this.tempSelf = null;
            this.tempData = null;
            this.formNote.resetFields();
          });
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    isRealValue(obj) {
      return obj && obj !== "null" && obj !== "undefined";
    },
    loadingTableTrue(table) {
      if (table === "idnotset") {
        this.loadingNotSet = true;
      } else if (table === "idurgent") {
        this.loadingUrgent = true;
      } else if (table === "idnormal") {
        this.loadingNormal = true;
      } else if (table === "idmedium") {
        this.loadingMedium = true;
      }
    },
    loadingTableFalse(table) {
      if (table === "idnotset") {
        this.loadingNotSet = false;
      } else if (table === "idurgent") {
        this.loadingUrgent = false;
        this.paginationUrgent.current = 1;
      } else if (table === "idnormal") {
        this.loadingNormal = false;
        this.paginationNormal.current = 1;
      } else if (table === "idmedium") {
        this.loadingMedium = false;
        this.paginationMedium.current = 1;
      }
    },

    initSetAttributeId() {
      let tableSet = document.getElementById("notset");
      let tbodyTableSet = tableSet.querySelector("tbody");
      tbodyTableSet.setAttribute("id", "idnotset");

      // // let tableNormal = document.getElementsByName('table-normal');
      // let tableUrgent = document.getElementById('urgent');
      // let tbodyTableUrgent = tableUrgent.querySelector("tbody");
      // tbodyTableUrgent.setAttribute('id','idurgent');

      // let tableMedium = document.getElementById('medium');
      // let tbodyTableMedium = tableMedium.querySelector("tbody");
      // tbodyTableMedium.setAttribute('id','idmedium');

      // let tableNormal = document.getElementById('normal');
      // let tbodyTableNormal = tableNormal.querySelector("tbody");
      // tbodyTableNormal.setAttribute('id','idnormal');
    },
    handleLink(id_pp) {
      const route = this.$router.resolve({
        name: "manifestPp",
        params: { id: id_pp },
      });
      window.open(route.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.float-right {
  float: right;
  text-align: right;
}
</style>
